export const PAGEVIEW = 'pageview';
export const PAGEVIEW_AJAX_SRP = 'pageview_ajax_srp';
export const PAGEVIEW_AJAX_PROJECT = 'pageview_ajax_project';
export const PAGEVIEW_AJAX_ARTICLE = 'pageview_ajax_article';
export const PROJECT_COMMENT = 'projectComment';
export const RELATED_PROJECT_CLICK = 'projectClick';
export const PROJECT_SUBSCRIBE_BUTTON_CLICK = 'projectContact';
export const ARTICLE_CLICK = 'articleClick';
export const RELATED_ARTICLE_CLICK = 'articleClick';
export const ARTICLE_TYPE_TAB_CLICK = 'articleTypeChange';
export const ARTICLE_CAROUSEL_ARROW_CLICK = 'articleCarousel';
export const ARTICLE_SHOW_MORE_CLICK = 'articleMore';
export const ARTICLE_READ_MORE_CLICK = 'articleReadMore';
export const ARTICLE_SUBMITTED_COMMENT = 'articleComment';
export const ARTICLE_PAGENAVIGATION = 'articleInPageNavigation';
export const ARTICLE_SUBSCRIBE_BUTTON_CLICK = 'projectContact';
export const ARTICLE_VIEW_ALL_CLICK = 'viewAllArticle';
export const ARTICLE_CLICK_ON_ARROW = 'articlePhotoNext';
export const ARTICLE_CLICK_ON_THUMBNAIL = 'articlePhotoThumbnailsClick';
export const ARTICLE_SEARCH = 'articleSearch';
export const GDPR_SHOW = 'gdprShow';
export const GDPR_CLOSE = 'gdprClose';
export const REGISTER_BUTTON_CLICK = 'userRegisterClick';
export const LOGIN_BUTTON_ClICK = 'userLoginClick';
export const WEB_VITALS = 'web-vitals';
export const HIGHLIGHT_TOPIC_CLICK = 'exploreArticleByTopics';
export const PROPERTY_TYPE_CLICK = 'exploreArticleByPropertyType';
export const EDITORS_PICKS_CAROUSEL_CLICK = 'articleCarousel';
export const ARTICLE_FEED_TAB_CLICK = 'articleTypeChange';
export const ARTICLE_FEED_SHOW_MORE_CLICK = 'articleMore';
export const NAVIGATION_ITEM_CLICK = 'Tab Interactions';
